import React from "react";
import {
  UserIcon,
  PiggyBankIcon,
  BuildingIcon,
  FactoryIcon,
  TagIcon,
  ChatTextIcon,
  Icon,
  IconProps,
  PencilIcon,
  BriefcaseIcon,
  ChartLineIcon,
  FileTextIcon,
  StackIcon,
  HandshakeIcon,
} from "@phosphor-icons/react";
import type { ViewKind } from "../types";

interface EntityIconProps extends IconProps {
  kind: ViewKind | "unknown";
}

const EntityIcon: React.FC<EntityIconProps> = ({ kind, ...props }) => {
  if (kind === "vehicle") {
    return <PiggyBankIcon {...props} />;
  }
  if (kind === "manager") {
    return <BuildingIcon {...props} />;
  }
  if (kind === "person") {
    return <UserIcon {...props} />;
  }
  if (kind === "company") {
    return <FactoryIcon {...props} />;
  }
  if (kind === "topic") {
    return <TagIcon {...props} />;
  }
  if (kind === "interaction") {
    // A conversation, not an edit: the pencil was doing double duty as the
    // update-verb mark and the interaction kind glyph, sometimes in the
    // same activity row (design round 7). The bubble matches the views
    // strip's own Interactions glyph.
    return <ChatTextIcon {...props} />;
  }
  if (kind === "client") {
    return <BriefcaseIcon {...props} />;
  }
  if (kind === "portfolio") {
    return <ChartLineIcon {...props} />;
  }
  if (kind === "deal") {
    return <HandshakeIcon {...props} />;
  }
  if (kind === "document") {
    return <FileTextIcon {...props} />;
  }
  if (kind === "shadowbook") {
    return <StackIcon {...props} />;
  }
  if (kind === "unknown") {
    return <PencilIcon {...props} />;
  }
  assertNever(kind);
};

export default EntityIcon;

function assertNever(x: never): never {
  throw new Error("Unknown entity kind: " + x);
}
